module.exports = __webpack_public_path__ + "static/img/11.623b1a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/sp/11.png
// module id = zeWf
// module chunks = 0